import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ALERT_BUTTONS_MESSAGES, ALERT_MESSAGES } from 'src/app/core/constants/AlertMessages';
import { EMAIL_VALIDATION } from 'src/app/core/constants/Errors';
import { Payment, Transaction } from 'src/app/models';
import { AlertService } from 'src/app/services/alert.service';
import { DepositsManageService } from 'src/app/services/deposits-manage.service';
import { PaymentMethodsService } from 'src/app/services/payment-methods.service';
import { PayvalidaFeatureFlagService } from 'src/app/services/payvalida-feature-flag.service';
import { EmailValidator } from 'src/app/tools/email-validator';
import { environment } from 'src/environments/environment';
import { SweetAlertIcon } from 'sweetalert2';

@Component({
  selector: 'app-sinpe-movil',
  templateUrl: './sinpe-movil.component.html',
  styleUrls: ['./sinpe-movil.component.scss']
})

export class SinpeMovilComponent implements OnInit {
  @Input() information: Payment;
  @Input() transaction: Transaction;
  @Output() SINPE = new EventEmitter();

  loading = true;
  formPrivacyValid = false;
  emailForm: FormGroup;
  buttonMessage = 'deposit-Send';
  template = '';
  orderID = '';
  errorsMessages = EMAIL_VALIDATION;
  rc_number: string = '' ;
  whatsappNumberInfo : string = environment.info_cr_payvalida_whatsapp_number;
  emailTo: string = environment.info_cr_payvalida_email;
  whatsapp_logo = environment.whatsapp_logo
  private parameter = 'sinpeMovilNewUiFF';
  private flag = 'sinpe-movil-new-ui-ff';
  private platform = 'payvalida';
  sinpeMovilCheckoutFf : boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private depositManager: DepositsManageService,
    private alertService: AlertService,
    private paymentService: PaymentMethodsService,
    private featureFlagService: PayvalidaFeatureFlagService

  ) {
    this.emailForm = this.formBuilder.group({
      email: ['', Validators.compose([
        Validators.required,
        Validators.maxLength(150),
        Validators.minLength(10),
        EmailValidator.isValid
      ])],
    });
  }

  ngOnInit(): void {
    this.featureFlagService.getFeatureFlagValue(this.parameter, this.flag, this.platform).subscribe((response : boolean) => {
      this.sinpeMovilCheckoutFf = response;
  });
    this.template = this.information.template;
    this.rc_number = this.information.concept[0].number;
    this.loadOrderInfo();
  }

  /**
   * @description {loadOrderInfo} Function to load info order
  */
  loadOrderInfo() {
    this.loading = true;
    this.paymentService.Order().then((response) => {
      response.OrderEmail ? this.emailForm.get('email').setValue(response.OrderEmail) : '';
    }).catch(() => {
      this.alertService.showAlertProblem();
    }).finally(() => this.loading = false);
  }

  /**
   * @description {changeMethod} Function that returns to payment methods
  */
  changeMethod() {
    this.SINPE.emit();
  }

  /**
   *
   * @description {formPrivacyUpdate} Function that obtains the event of the validation of the child component
   * @param valid
  */
  formPrivacyUpdate(valid: boolean) {
    this.formPrivacyValid = valid;
  }

  /**
   *
   * @description {completedForms} Function to validate the validations of the parent component and child component
   * @returns
  */
  completedForms() {
    return this.emailForm.valid && this.formPrivacyValid;
  }

  /**
   * @description {sendEmail} Function to send transaction email with rate limit
  */
  sendEmail() {
    this.loading = true;
    if (this.emailForm.valid) {
      this.depositManager.sendEmailWithLimit(this.transaction.ORDER_CODE.toString(), this.emailForm.get('email').value).subscribe({
        next: (response) => {
          if (response) {
            this.buildResponse(ALERT_MESSAGES.EMAIL_SENT, ALERT_MESSAGES.EMAIL_SENT_MESSAGE, 'success');
            return;
          }
          this.alertService.showAlertProblem();
          this.loading = false;
        }, error: () => {
          this.buildResponse(ALERT_MESSAGES.EMAIL_NOT_SENT, ALERT_MESSAGES.EMAIL_NOT_SENT_RATE_LIMIT, 'error');
        },
      });
    }
  }
  /**
   *
   * @description {buildResponse} Function to build sendEmail response service
   * @param title alert title
   * @param message alert message
   * @param icon alert icon
  */
  buildResponse(title: string, message: string, icon: SweetAlertIcon) {
    this.alertService.showPopup(
      title,
      message,
      icon,
      ALERT_BUTTONS_MESSAGES.THANKS
    );
    this.loading = false;
  }

  /**
   * @description {ngAfterViewInit} Function to assign styles to component after it has been initialized
  */
  ngAfterViewInit(): void {
    let elements = document.querySelectorAll('app-counter-item');
    elements.forEach((item) => {
      let container = item.querySelector('.counterContainer');
      container.classList.add('customCounterContainer');
    });
  }

  /**
   * @description {formatWhatsAppNumber}  function that takes a raw phone number and formats it into a WhatsApp number format with a country code prefix and spaces.
   * @param rawNumber support whatsapp Number to provide and format
  */
  formatWhatsAppNumber(rawNumber: string): string {
    const countryCode = rawNumber.slice(0, 2);
    const areaCode = rawNumber.slice(2, 5);
    const firstPart = rawNumber.slice(5, 8);
    const secondPart = rawNumber.slice(8);

    return `+${countryCode} ${areaCode} ${firstPart} ${secondPart}`;
  }
}
